import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SectionManager = () => {
  const [sections, setSections] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    slug: '',
    description: '',
    order_index: 0,
    page: 'sponsors',
    is_active: true
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchSections();
  }, []);

  const fetchSections = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.get('/api/sections?page=sponsors', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSections(response.data);
    } catch (error) {
      console.error('Error fetching sections:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('adminToken');

      if (editingItem) {
        await axios.put(`/api/sections/${editingItem.id}`, formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axios.post('/api/sections', formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }

      fetchSections();
      resetForm();
    } catch (error) {
      console.error('Error saving section:', error);
      alert('Kaydetme hatası: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu başlığı silmek istediğinizden emin misiniz? İlgili sponsorlar kategorisiz kalacak.')) {
      return;
    }

    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`/api/sections/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchSections();
    } catch (error) {
      console.error('Error deleting section:', error);
      alert('Silme hatası');
    }
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({
      title: item.title,
      slug: item.slug,
      description: item.description || '',
      order_index: item.order_index,
      page: item.page,
      is_active: item.is_active
    });
    setShowForm(true);
  };

  const resetForm = () => {
    setFormData({
      title: '',
      slug: '',
      description: '',
      order_index: 0,
      page: 'sponsors',
      is_active: true
    });
    setEditingItem(null);
    setShowForm(false);
  };

  const generateSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/ı/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  };

  return (
    <div className="bg-gradient-card rounded-xl p-6 border border-accent/30">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-accent">Başlık Yönetimi</h2>
        <button
          onClick={() => setShowForm(!showForm)}
          className="bg-accent hover:bg-accent-dark text-white px-4 py-2 rounded-lg transition-colors"
        >
          {showForm ? 'İptal' : '+ Yeni Başlık'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="bg-navy-700 p-6 rounded-lg mb-6 space-y-4">
          <div>
            <label className="block text-white mb-2">Başlık *</label>
            <input
              type="text"
              value={formData.title}
              onChange={(e) => {
                const title = e.target.value;
                setFormData({ 
                  ...formData, 
                  title,
                  slug: editingItem ? formData.slug : generateSlug(title)
                });
              }}
              className="w-full px-3 py-2 bg-navy-600 border border-accent/30 rounded text-white"
              required
            />
          </div>

          <div>
            <label className="block text-white mb-2">Slug (URL için) *</label>
            <input
              type="text"
              value={formData.slug}
              onChange={(e) => setFormData({ ...formData, slug: e.target.value })}
              className="w-full px-3 py-2 bg-navy-600 border border-accent/30 rounded text-white"
              required
            />
          </div>

          <div>
            <label className="block text-white mb-2">Açıklama</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              className="w-full px-3 py-2 bg-navy-600 border border-accent/30 rounded text-white"
              rows="2"
            />
          </div>

          <div>
            <label className="block text-white mb-2">Sıra</label>
            <input
              type="number"
              value={formData.order_index}
              onChange={(e) => setFormData({ ...formData, order_index: parseInt(e.target.value) })}
              className="w-full px-3 py-2 bg-navy-600 border border-accent/30 rounded text-white"
            />
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={formData.is_active}
              onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
              className="w-4 h-4"
            />
            <label className="text-white">Aktif</label>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-accent hover:bg-accent-dark text-white font-bold py-2 px-4 rounded-lg transition-colors disabled:opacity-50"
          >
            {loading ? 'Kaydediliyor...' : (editingItem ? 'Güncelle' : 'Ekle')}
          </button>
        </form>
      )}

      <div className="space-y-4">
        {sections.map((section) => (
          <div key={section.id} className="bg-navy-700 p-4 rounded-lg">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <h3 className="text-white font-bold text-lg">{section.title}</h3>
                <p className="text-white/60 text-sm">Slug: {section.slug}</p>
                {section.description && (
                  <p className="text-white/60 text-sm">Açıklama: {section.description}</p>
                )}
                <p className="text-white/60 text-sm">Sıra: {section.order_index} | Durum: {section.is_active ? 'Aktif' : 'Pasif'}</p>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => handleEdit(section)}
                  className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
                >
                  Düzenle
                </button>
                <button
                  onClick={() => handleDelete(section.id)}
                  className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                >
                  Sil
                </button>
              </div>
            </div>
          </div>
        ))}

        {sections.length === 0 && (
          <p className="text-center text-white/60 py-8">Henüz başlık eklenmedi</p>
        )}
      </div>
    </div>
  );
};

export default SectionManager;
